import React, { useState } from 'react';

const MAX_RESUMES = 2;

function ResumeGen() {
    const [prompt, setPrompt] = useState('');
    const [resume, setResume] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [count, setCount] = useState(() => parseInt(localStorage.getItem('resumeCount') || '0'));

    const handleGenerate = async () => {
        if (!prompt.trim()) return alert('Apni details likho pehle!');
        if (count >= MAX_RESUMES) {
            return alert('Aap sirf 2 resume bana sakte hain. Limit khatam ho gayi.');
        }
        setLoading(true);
        setResume('');
        setError('');

        try {
            const response = await fetch('http://localhost:5000/api/ai/resume', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ prompt }),
            });
            const data = await response.json();
            if (data.resume) {
                setResume(data.resume);
                const newCount = count + 1;
                setCount(newCount);
                localStorage.setItem('resumeCount', newCount);
            } else {
                setError('Resume generate nahi hua. Dobara try karo.');
            }
        } catch (err) {
            setError('Server se connect nahi ho pa raha.');
        } finally {
            setLoading(false);
        }
    };

    const handlePrint = () => {
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>Resume - JobFreedom</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { font-family: 'Arial', sans-serif; background: #fff; }
        .page {
          width: 210mm;
          min-height: 297mm;
          display: flex;
          margin: 0 auto;
        }

        /* LEFT SIDEBAR */
        .sidebar {
          width: 35%;
          background: #4A3F6B;
          color: white;
          padding: 30px 20px;
          min-height: 297mm;
        }
        .avatar {
          width: 80px; height: 80px;
          background: #6B5B9E;
          border-radius: 50%;
          margin: 0 auto 16px;
          display: flex; align-items: center; justify-content: center;
          font-size: 32px; color: white;
          border: 3px solid rgba(255,255,255,0.3);
        }
        .sidebar-name {
          text-align: center;
          font-size: 18px;
          font-weight: bold;
          letter-spacing: 1px;
          text-transform: uppercase;
          margin-bottom: 4px;
        }
        .sidebar-role {
          text-align: center;
          font-size: 11px;
          opacity: 0.7;
          margin-bottom: 24px;
          letter-spacing: 1px;
        }
        .sidebar-section {
          margin-bottom: 20px;
        }
        .sidebar-section-title {
          font-size: 10px;
          letter-spacing: 2px;
          text-transform: uppercase;
          opacity: 0.6;
          border-bottom: 1px solid rgba(255,255,255,0.2);
          padding-bottom: 4px;
          margin-bottom: 10px;
        }
        .sidebar-item {
          font-size: 11px;
          line-height: 1.8;
          opacity: 0.9;
        }
        .skill-bar {
          background: rgba(255,255,255,0.2);
          border-radius: 4px;
          height: 4px;
          margin-top: 2px;
          margin-bottom: 8px;
        }
        .skill-fill {
          background: #FF6B00;
          height: 4px;
          border-radius: 4px;
        }

        /* RIGHT MAIN */
        .main {
          width: 65%;
          padding: 30px 25px;
          background: #fff;
        }
        .main-section {
          margin-bottom: 22px;
        }
        .main-section-title {
          font-size: 12px;
          font-weight: bold;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #4A3F6B;
          border-left: 4px solid #FF6B00;
          padding-left: 10px;
          margin-bottom: 10px;
        }
        .main-section p, .main-section li {
          font-size: 11px;
          line-height: 1.8;
          color: #444;
        }
        .main-section ul { list-style: none; padding: 0; }
        .main-section ul li::before { content: "▸ "; color: #FF6B00; }
        pre {
          white-space: pre-wrap;
          font-family: Arial, sans-serif;
          font-size: 11px;
          line-height: 1.8;
          color: #444;
        }

        /* FOOTER */
        .footer {
          position: fixed;
          bottom: 8px;
          right: 12px;
          font-size: 9px;
          color: #aaa;
        }

        @media print {
          body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
          .page { margin: 0; }
          .footer { position: fixed; bottom: 8px; right: 12px; }
        }
      </style>
    </head>
    <body>
      <div class="page">

        <!-- LEFT SIDEBAR -->
        <div class="sidebar">
          <div class="avatar">👤</div>
          <div class="sidebar-name">Professional</div>
          <div class="sidebar-role">Resume</div>

          <div class="sidebar-section">
            <div class="sidebar-section-title">Contact</div>
            <div class="sidebar-item">📍 Bihar, India</div>
            <div class="sidebar-item">📞 See resume</div>
            <div class="sidebar-item">✉ See resume</div>
          </div>

          <div class="sidebar-section">
            <div class="sidebar-section-title">Skills</div>
            <div class="sidebar-item">Technical Skills</div>
            <div class="skill-bar"><div class="skill-fill" style="width:80%"></div></div>
            <div class="sidebar-item">Communication</div>
            <div class="skill-bar"><div class="skill-fill" style="width:70%"></div></div>
            <div class="sidebar-item">Teamwork</div>
            <div class="skill-bar"><div class="skill-fill" style="width:85%"></div></div>
            <div class="sidebar-item">Problem Solving</div>
            <div class="skill-bar"><div class="skill-fill" style="width:75%"></div></div>
          </div>

          <div class="sidebar-section">
            <div class="sidebar-section-title">Generated by</div>
            <div class="sidebar-item" style="color:#FF6B00;font-weight:bold;">JobFreedom.in</div>
            <div class="sidebar-item" style="font-size:9px;opacity:0.6;">Bihar's #1 Job Portal</div>
          </div>
        </div>

        <!-- RIGHT MAIN -->
        <div class="main">
          <div class="main-section">
            <div class="main-section-title">Resume Details</div>
            <pre>${resume}</pre>
          </div>
        </div>

      </div>

      <div class="footer">JobFreedom.in | Bihar's #1 Job Portal</div>

      <script>
        window.onload = function() {
          window.print();
          window.onafterprint = function() { window.close(); }
        }
      </script>
    </body>
    </html>
  `);
        printWindow.document.close();
    };

    return (
        <main className="bg-dark-300 min-h-screen py-16 px-4">
            <div className="max-w-4xl mx-auto">

                {/* Header */}
                <div className="text-center mb-10">
                    <div className="text-5xl mb-4">🤖</div>
                    <h1 className="font-display text-3xl font-bold text-white mb-2">
                        AI Resume Generator
                    </h1>
                    <p className="text-gray-400">
                        Apni details likho — AI tumhara professional resume banayega
                    </p>
                    {/* Resume counter */}
                    <div className="mt-3">
                        <span className={`text-sm font-semibold px-4 py-1 rounded-full ${count >= MAX_RESUMES
                            ? 'bg-red-500/20 text-red-400'
                            : 'bg-saffron-500/20 text-saffron-400'
                            }`}>
                            {count >= MAX_RESUMES
                                ? '❌ Resume limit khatam (2/2)'
                                : `✅ ${MAX_RESUMES - count} resume baaki hain`}
                        </span>
                    </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

                    {/* Left — Input */}
                    <div className="bg-dark-200 border border-gray-800 rounded-3xl p-8">
                        <h3 className="text-white font-semibold mb-2">Apni Details Likho</h3>
                        <p className="text-gray-500 text-sm mb-4">Hindi ya English mein likh sakte ho</p>

                        <div className="bg-dark-300 border border-gray-700 rounded-xl p-4 mb-4 text-sm text-gray-400">
                            <p className="text-saffron-500 text-xs font-semibold mb-2">EXAMPLE:</p>
                            Mera naam Rahul Kumar hai. Main Patna Bihar ka rehne wala hun.
                            Maine ITI Electrician 2022 mein pass kiya Govt ITI Patna se.
                            Mujhe wiring aur electrical fitting ka 2 saal ka experience hai.
                            Meri age 24 saal hai. Phone: 9876543210
                        </div>

                        <textarea
                            rows={8}
                            value={prompt}
                            onChange={(e) => setPrompt(e.target.value)}
                            placeholder="Yahan apni details likho..."
                            disabled={count >= MAX_RESUMES}
                            className="w-full bg-dark-300 border border-gray-700 focus:border-saffron-500 text-white rounded-xl px-4 py-3 outline-none transition placeholder-gray-600 resize-none text-sm mb-4 disabled:opacity-50"
                        />

                        <button
                            onClick={handleGenerate}
                            disabled={loading || count >= MAX_RESUMES}
                            className="w-full bg-saffron-500 hover:bg-saffron-600 disabled:opacity-50 text-white font-semibold py-4 rounded-full transition shadow-lg shadow-saffron-500/30"
                        >
                            {loading ? (
                                <span className="flex items-center justify-center gap-2">
                                    <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24" fill="none">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                                    </svg>
                                    Resume ban raha hai...
                                </span>
                            ) : count >= MAX_RESUMES ? '❌ Limit Khatam' : '✨ Resume Banao'}
                        </button>

                        {error && (
                            <div className="mt-4 bg-red-500/10 border border-red-500/30 text-red-400 text-sm rounded-xl px-4 py-3">
                                ❌ {error}
                            </div>
                        )}
                    </div>

                    {/* Right — Output */}
                    <div className="bg-dark-200 border border-gray-800 rounded-3xl p-8">
                        <div className="flex justify-between items-center mb-6">
                            <h3 className="text-white font-semibold">Generated Resume</h3>
                            {resume && (
                                <button
                                    onClick={handlePrint}
                                    className="flex items-center gap-2 text-saffron-500 hover:text-saffron-400 text-sm border border-saffron-500/30 px-4 py-1 rounded-full transition"
                                >
                                    🖨️ Print / Save PDF
                                </button>
                            )}
                        </div>

                        {!resume && !loading && (
                            <div className="text-center py-16 text-gray-600">
                                <div className="text-5xl mb-4">📄</div>
                                <p className="text-sm">Resume yahan dikhega</p>
                            </div>
                        )}

                        {loading && (
                            <div className="text-center py-16">
                                <div className="text-5xl mb-4 animate-bounce">🤖</div>
                                <p className="text-gray-400 text-sm">AI resume bana raha hai...</p>
                            </div>
                        )}

                        {resume && (
                            <div className="bg-white rounded-xl overflow-hidden">
                                {/* Preview Header */}
                                <div className="bg-gradient-to-r from-orange-600 to-orange-500 px-6 py-4">
                                    <h2 className="text-white font-bold text-lg tracking-widest uppercase">Professional Resume</h2>
                                    <p className="text-orange-100 text-xs mt-1">Generated by JobFreedom</p>
                                </div>
                                {/* Preview Body */}
                                <div className="p-6">
                                    <pre className="whitespace-pre-wrap text-gray-800 text-xs leading-relaxed font-sans">
                                        {resume}
                                    </pre>
                                </div>
                                {/* Preview Footer */}
                                <div className="bg-gray-50 border-t-2 border-orange-500 px-6 py-2 text-center text-xs text-gray-400">
                                    JobFreedom.in | Patna, Bihar
                                </div>
                            </div>
                        )}
                    </div>

                </div>

            </div>
        </main>
    );
}

export default ResumeGen;